@if (inputControl) {
  <rt-input
    [formControl]="inputControl.controls.data"
    [placeholder]="'app.views.filters.input_text_placeholder' | translate"
  />
}
